import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

interface RuntimeConfigResponse {
  apiUrl?: string;
  frontendUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  public async load(): Promise<void> {
    try {
      const response = await fetch('/assets/env.json', {
        cache: 'no-store',
      });

      if (!response.ok) {
        return;
      }

      const config = (await response.json()) as RuntimeConfigResponse;
      if (config.apiUrl) {
        environment.apiUrl = config.apiUrl;
      }
    } catch {
      // Keep static environment defaults when runtime config is unavailable.
    }
  }
}
